import { useEffect, useRef } from 'react';
import { useTheme } from '../hooks/use-theme';
import { useSamsungSitesMode } from '../hooks/use-samsung-sites-mode';

/**
 * When Samsung Internet Dark Sites is on, keep the site in dark mode without
 * overwriting the user's saved theme preference. Restore preference when Dark
 * Sites turns off.
 */
export function SamsungThemeSync() {
  const { setTheme } = useTheme();
  const { isSamsungDarkSites, sitesMode } = useSamsungSitesMode();
  const wasForcedDark = useRef(false);

  useEffect(() => {
    if (isSamsungDarkSites) {
      wasForcedDark.current = true;
      setTheme('dark', { save: false });
      return;
    }

    if (!wasForcedDark.current || sitesMode !== 'light-sites') return;

    wasForcedDark.current = false;
    const stored = localStorage.getItem('theme');
    if (stored === 'light' || stored === 'dark') {
      setTheme(stored);
      return;
    }

    setTheme('light', { save: false });
  }, [isSamsungDarkSites, sitesMode, setTheme]);

  return null;
}
